import { AcademicCapIcon } from '@heroicons/react/solid';
import React from 'react';
import PropTypes from 'prop-types';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import StarIcon from '@mui/icons-material/Star';
import colors from '@/styles/colors';
import { StyledContainer } from './styles';
import { GLOBAL_CONSTANTS } from '@/utils/globalConstants';

export default function AcademicTimeline({ academicDetails }) {
  const {
    academicTimelines: { iconStyle, icons },
  } = GLOBAL_CONSTANTS;

  const sortedAcademicData = [...academicDetails]?.sort((a, b) => {
    const dateA = Number(a?.date?.split('-')[1]?.trim());
    const dateB = Number(b?.date?.split('-')[1]?.trim());
    return dateB - dateA;
  });

  return (
    <StyledContainer id="academic" className="px-4 py-10 mx-auto">
      <div className="flex items-center">
        <AcademicCapIcon className="w-10 inline-block mr-4" color={colors.lighter} />
        <h1 className="sm:text-4xl text-3xl font-medium title-font text-white">Academic Timeline</h1>
      </div>
      <VerticalTimeline>
        {sortedAcademicData.map(({ _id, title, board, description, iconName, date }) => (
          <VerticalTimelineElement
            key={_id}
            className="vertical-timeline-element--work"
            contentStyle={{ background: `linear-gradient(${colors.black}, ${colors.dark})`, color: colors.lighter }}
            contentArrowStyle={{ borderRight: `7px solid linear-gradient(${colors.black}, ${colors.dark})` }}
            date={date}
            iconStyle={iconStyle}
            icon={icons[iconName]}
          >
            <h3 className="vertical-timeline-element-title">{title}</h3>
            <h4 className="vertical-timeline-element-subtitle">{board}</h4>
            <p>{description}</p>
          </VerticalTimelineElement>
        ))}
        <VerticalTimelineElement iconStyle={{ background: 'rgba(17, 24, 39)', color: '#fff' }} icon={<StarIcon />} />
      </VerticalTimeline>
    </StyledContainer>
  );
}

AcademicTimeline.propTypes = {
  academicDetails: PropTypes.oneOfType([PropTypes.array]).isRequired,
};
